import { z } from 'zod';
import { ActionSchema } from '../actions';

export const LiveTileBlockSchema = z.object({
  id: z.string().min(1),
  type: z.literal('live_tile'),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(ActionSchema).optional() }).optional(),
  props: z.object({
    data_key: z.string().min(1),
    label: z.string().min(1),
    unit: z.string().optional(),
    format: z.enum(['number', 'text', 'boolean']),
    thresholds: z.array(z.object({
      gte: z.number().optional(),
      lte: z.number().optional(),
      colour: z.string().min(1)
    })).optional(),
    toggle: z.object({ on: ActionSchema, off: ActionSchema }).optional()
  })
});